import {
    ApiHandler,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import {
    loadScheduleData,
    ScheduleDataApiModel,
    ScheduleDataParameter
} from "@gemeco/Services/GemecoInventoryDataService";

type HandlerType = ApiHandler<ScheduleDataParameter, ScheduleDataApiModel>;

export const RequestDataFromScheduleApi: HandlerType = async (props: any) => {
    props.apiResult = await loadScheduleData(props.parameter);
};

export const chain = [RequestDataFromScheduleApi];

const gemecoScheduleHandler = createHandlerChainRunner(chain, "GemecoScheduleHandler");
export default gemecoScheduleHandler;
